export default __webpack_public_path__ + "static/media/ios-sync.a35f9880.svg";